export enum ServerErrorCodes {
  GENERIC_ERROR = 'Η διαδικασία απέτυχε. Παρακαλώ δοκιμάστε ξανα αργότερα.',
  WRONG_LOGIN = 'Τα στοιχεία χρήστη που πληκτρολογήσατε δεν είναι σωστά. Παρακαλώ προσπαθήστε ξανά.',
  UNCONFIRMED = 'To email του χρήστη δεν έχει επαληθευτεί, επικοινωνήστε με τον διαχειριστή της εφαρμογής.',
  EXCELTEMPLATEWASNOTFOUND = 'Δέν βρέθηκε το πρότυπο για την δημιουργία του αρχείου. Παρακαλώ επικοινωνήστε με τον διαχειριστή.',
  FILEISEMPTY = 'Το αρχείο δεν περιέχει εγγραφές.',
  EMAILTEMPLATEWASNOTFOUND = 'Δέν βρέθηκε το πρότυπο για την αποστολή του email. Παρακαλώ επικοινωνήστε με τον διαχειριστή.',
  EMPTY_DATA = 'Αδυναμία εύρεσης δεδομένων.Παρακαλώ επικοινωνήστε με τον διαχειριστή.',
  USERALREADYEXISTS = 'Υπάρχει καταχωρημένος χρήστης με το ίδιο email ή το ίδιο username.',
  USEREMAILALREADYEXISTS = 'Υπάρχει ήδη καταχωρημένος χρήστης με το ίδιο email.',
  DUPLICATEUSERNAME = 'Το username είναι ήδη δεσμευμένο',
  DUPLICATEEMAIL = 'Το email είναι ήδη δεσμευμένο',
  INVALIDUSERNAME = 'Το username δεν πληρεί τις προδιαγραφές.',
  INVALIDEMAIL = 'Το email είναι λάθος',
  PASSWORDTOOSHORT = 'Επιλέξτε κωδικό τουλάχιστον 8 χαρακτήρων',
  PASSWORDREQUIRESNONALPHANUMERIC = 'Επιλέξτε κωδικό που να περιέχει τουλάχιστον ένα σύμβολο.',
  PASSWORDREQUIRESDIGIT = 'Επιλέξτε κωδικό που να περιέχει τουλάχιστον ένα αριθμό',
  PASSWORDREQUIRESLOWER = 'Επιλέξτε κωδικό που να περιέχει τουλάχιστον ένα μικρό γράμμα',
  PASSWORDREQUIRESUPPER = 'Επιλέξτε κωδικό που να περιέχει τουλάχιστον ένα κεφαλαίο γράμμα',
  PASSWORDS_DO_NOT_MATCH = 'Ο κωδικός πρόσβασης και η επαλήθευση κωδικού δεν ταιριάζουν.',
  USERALREADYHASPASSWORD = 'Έχετε ήδη καταχωρήσει κωδικό πρόσβασης',
  USERLOCKOUTNOTENABLED = 'Ο χρήστης είναι κλειδωμένος, επικοινωνήστε με τον διαχειριστή της εφαρμογής',
  USERNOTINROLE = 'Ο χρήστης δεν έχει τον απαιτούμενο ρόλο',
  USERALREADYINROLE = 'Ο χρήστης ανήκει ήδη στον ζητούμενο ρόλο',
  INVALIDTOKEN = 'Ο σύνδεσμος έχει λήξει, επικοινωνήστε με τον διαχειριστή της εφαρμογής',
  USER_NOT_FOUND = 'Δεν βρέθηκε χρήστης με αυτό το email.',
  INVALID_OTP = 'Το OTP δεν είναι έγκυρο.',
  MAX_RETRIES_EXCEEDED = 'Έχετε ξεπεράσει τον μέγιστο αριθμό προσπαθειών. Παρακαλώ ζητήστε νέο OTP.',
}
